import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { EnvironmentParameters } from 'app/environment/models/environment-parameters';
import { EnvironmentDataService } from 'app/environment/services/environment.data.service';
import { BzgModalService } from 'bz-genome-angular';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import { ICountryCode, ISmsNumber } from 'app/environment/typings/ismsNumber';
import { IFilterColumn } from 'app/scheduler/jobs/IFilterColumn';

@Component({
    selector: 'sms-configuration',
    templateUrl: 'sms-configuration.component.html',
    styleUrls: ['sms-configuration.component.scss']
})
export class SmsConfigurationComponent {

    @Input() parameters: EnvironmentParameters;
    @Input() metadata: any;

    @ViewChild('smsConfigurationForm', { static: false}) smsConfigurationForm: NgForm;
    @ViewChild('smsAddNumberForm', { static: true}) smsAddNumberForm: NgForm;

    public smsTwilioFromNumbersArray: Array<ISmsNumber>;
    public smsProviders: Array<any>;
    public countries: Array<ICountryCode>;

    public additionNumber: ISmsNumber = {
		number: '',
		isDefault: false,
		countryCodesTo: []
    }

    public editModeNumber: ISmsNumber;
    public editingRowIndex: number;

    public columns: Array<IFilterColumn> = [
        { key: 'isDefault', value: 'ENVIRONMENT.DEFAULT', visible: true, type: 'boolean' },
        { key: 'number', value: 'ENVIRONMENT.NUMBER', visible: true, type: 'text' },
        { key: 'countryCodesTo', value: 'ENVIRONMENT.COUNTRY_CODES_ASSOCIATED', visible: true, type: 'array' },
        { key: 'actions', value: 'ENVIRONMENT.ACTIONS', visible: true, type: 'action' }
    ];

    public SMS_NUMBER_REGEXP = /^(\+[0-9]+)$/

    constructor(private _modalService: BzgModalService, private _environmentDataService: EnvironmentDataService) {}

    async ngOnInit() {
        this.smsProviders = await this._environmentDataService.getSMSProviders();
        this.countries = await this._environmentDataService.getCountryCodeNumbers();
    };

    ngOnChanges(): void {
      if (this.parameters.smsTwilioFromNumbers)
        this.smsTwilioFromNumbersArray = JSON.parse(this.parameters.smsTwilioFromNumbers);
    }

    public getCommaSeparatedString(array: Array<ISmsNumber>) {
        return _.map(array, 'countryCode').join(', ');
    }

    public numberAlreadyExists(numberValue: string) {
        return _.find(this.smsTwilioFromNumbersArray, ['number', numberValue]) ? true : false;
    }

    public addNumber() {
        if(!this.smsTwilioFromNumbersArray) {
            this.smsTwilioFromNumbersArray = [];
        }

        this.smsTwilioFromNumbersArray.push(_.cloneDeep(this.additionNumber));
		this.parameters.smsTwilioFromNumbers = JSON.stringify(this.smsTwilioFromNumbersArray);
		this.additionNumber = {
			number: '',
			isDefault: false,
			countryCodesTo: []
        }

        this._cleanErrorMessages(this.smsAddNumberForm);
    }

    public startNumberEdition(currentNumber: ISmsNumber, index: number) {
        this.editingRowIndex = index;
		this.editModeNumber = _.cloneDeep(currentNumber);
	}

	public finishNumberEdition(index: number) {
        this.smsTwilioFromNumbersArray[index] = this.editModeNumber;
        this.parameters.smsTwilioFromNumbers = JSON.stringify(this.smsTwilioFromNumbersArray);
        this.editingRowIndex = null;
		this.editModeNumber = null;
    }

    public showDeleteConfirmation(currentNumber: ISmsNumber) {
        const modal = this._modalService.open(DeleteConfirmationComponent, {
            closeOnBackdropClick: false,
            closeOnRouterNavigation: true,
            data: {
            title: 'ENVIRONMENT.DELETE_DEFAULT_NUMBER',
            message: 'ENVIRONMENT.DELETE_DEFAULT_NUMBER_MESSAGE',
            button: 'ENVIRONMENT.DELETE_NUMBER_OK_BUTTON'
            }
        });
        modal.afterClosed().subscribe((result: string) => {
            if (result === 'delete') {
                this.removeNumber(currentNumber);
            }
        });
    }

    public onRemoveNumber(currentNumber: ISmsNumber) {
        if(currentNumber.isDefault) {
            this.showDeleteConfirmation(currentNumber);
        } else {
            this.removeNumber(currentNumber);
        }
    }

    public isFormValid(): boolean {
        if (this.smsConfigurationForm.valid) {
          this.transformEmptyNumber();
        }
        return this.smsConfigurationForm.valid;
    }

    public isInvalidNumberToAdd(): boolean {
        return (
          this.smsAddNumberForm.invalid ||
          this.additionNumber.countryCodesTo.length === 0 ||
          this.numberAlreadyExists(this.additionNumber.number)
        );
    }

    public isInvalidNumberForEdit(): boolean {
        return (
          this.editModeNumber &&
          (!this.SMS_NUMBER_REGEXP.test(this.editModeNumber.number) ||
            this.editModeNumber.countryCodesTo.length === 0)
        );
    }

    public selectDefault(index: number) {
        _.forEach(this.smsTwilioFromNumbersArray, function(number) {
            number.isDefault = false;
        });

        this.smsTwilioFromNumbersArray[index].isDefault = true;
        this.parameters.smsTwilioFromNumbers = JSON.stringify(this.smsTwilioFromNumbersArray);
    }

    private transformEmptyNumber() {
      _.each(this.smsConfigurationForm.controls, (value, key) => {
        if (this.metadata[key] && this.metadata[key].type === 'number' && this.parameters[key] === "") {
          this.parameters[key] = null;
        }
      })

    }

    private removeNumber(currentNumber: ISmsNumber) {
        _.remove(this.smsTwilioFromNumbersArray, function(n) {
            return n === currentNumber;
        });

        this.parameters.smsTwilioFromNumbers = JSON.stringify(this.smsTwilioFromNumbersArray);
    }

    private _cleanErrorMessages(form: NgForm) {
        Object.keys(form.form.controls).map(function (c) {
          const control = form.form.controls[c];
          control.reset();
        });
    }
}
